/* eslint-disable */

import { toFixedRoundDown } from "./to-fixed-round-down"

interface ShortestValue {
  value: string
  decimals: number
  minDecimals?: number
  maxDecimals?: number
}

/**
 * Return a string value that shows an amount with the shortest number of decimal places.
 *
 * This allows for a more compact display of values without every showing 0.00 when there isd actually a value
 *
 * @returns
 */
export const shortestValue = ({ value, decimals, minDecimals, maxDecimals }: ShortestValue): string => {
  const decimalPlaces = [2, 3, 4, 5, 6, 8, 12, 18]
  const zeroValue = Number(0).toFixed(minDecimals || 2)
  if (!value) {
    return zeroValue
  }

  for (let i = 0; i < decimalPlaces.length; i++) {
    const decimalPlace = decimalPlaces[i]

    if (!decimalPlace) {
      return "0"
    }

    if (minDecimals && decimalPlace && decimalPlace < minDecimals) {
      continue
    }
    if (decimalPlace && decimalPlace > decimals) {
      return zeroValue
    }

    // we want to display up to max decimals to ensure the value always fits inside the UI
    // if decimalPlaces > maxDecimals, then we will show the maxDecimals
    if (maxDecimals && decimalPlace && decimalPlace > maxDecimals) {
      return toFixedRoundDown(value, maxDecimals)
    }

    const shortValue = toFixedRoundDown(value, decimalPlace) ?? "0"
    const shortZeros = "0.".padEnd(decimalPlace + 2, "0")
    if (shortValue !== shortZeros) {
      return shortValue
    }
  }

  return zeroValue
}
